<h1 mat-dialog-title><i class="fad fa-question-circle text-info cursor-pointer"
        (click)="openTutorial()"></i>&nbsp;&nbsp; Abrir chamado</h1>
<div mat-dialog-content class="border-top border-bottom">
    <form class="mt-3 mb-3 text-left" autocomplete="off">
        <div class="mb-2">
            <label for="productSelect" class="text-left d-block">Produto:</label>
            <select name="product" id="productSelect" class="form-control mt-md-0" [(ngModel)]="product"
                (change)="onProductChanged($event)" [ngModelOptions]="{standalone: true}" #selection>
                <option *ngIf="hasTareffa">Tareffa</option>
                <option *ngIf="hasAtendimentoCliente">Atendimento ao Cliente</option>
                <option *ngIf="hasIntegrador">Integrador</option>
                <option value="Busca-Extrato" *ngIf="hasBuscaExtrato">Busca Extrato</option>
                <option value="Bussola">Bússola</option>
            </select>
        </div>
        <div class="mb-2">
            <label for="typeSelect">Tipo de atendimento:</label>
            <select id="typeSelect" class="form-control mt-md-0" [(ngModel)]="type" (change)="onTypeChanged($event)"
                [ngModelOptions]="{standalone: true}" #selection>
                <option>Dúvida</option>
                <option value="BUGFIX - BUG Produto">Problema</option>
                <option value="Melhoria">Sugestão de melhoria</option>
                <option value="Service - Criação Layout / Mapeamento Documento">Novo layout / Novo serviço</option>
            </select>
        </div>
        <div *ngIf="canSelectCompany" class="mb-2">
            <small>Empresa:</small>
            <ottimizza-company-selector (companySelected)="company = $event"></ottimizza-company-selector>
        </div>
        <section>
            <label for="textarea-chamados">Relate {{problemType}}:</label>
            <textarea id="textarea-chamados" maxlength="3000" rows="10" class="form-control" name="mensagem"
                [(ngModel)]="message"></textarea>
            <small class="float-right">{{ message.length }} / 3000</small>
            <br><br>
            <app-upload *ngIf="product !== ''" (fileChange)="upload($event)"></app-upload>
        </section>
    </form>
</div>
<div mat-dialog-actions class="text-center">
    <div class="container-fluid px-0 py-3 justify-content-between">
        <button class="btn btn-light text-danger mx-2" (click)="dialogRef.close()">Cancelar</button>
        <button class="btn btn-primary text-light mx-2" *ngIf="!isUploading" (click)="confirm()"
            [disabled]="(!company && canSelectCompany) || !product || !message || isConfirming">Enviar</button>
        <button class="btn btn-primary text-light mx-2" *ngIf="isUploading" [disabled]="true">
            <i class="fad fa-spinner rotate-constant"></i>&nbsp;&nbsp;
            Salvando arquivo...
        </button>
    </div>
</div>